import { render, staticRenderFns } from "./ProductionTimeOptionsBlock.vue?vue&type=template&id=6a7115f1&"
import script from "./ProductionTimeOptionsBlock.vue?vue&type=script&lang=ts&"
export * from "./ProductionTimeOptionsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionTimeOptionsBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VSimpleTable,VTextField})
